import { ATTACH_ACTION_SELECT_ACTION_FILE } from './AttachActionSelect.constants'

export function isAttachActionSelectActionFile(value) {
  return value === ATTACH_ACTION_SELECT_ACTION_FILE
}
